module.exports = __webpack_public_path__ + "files/eaad0d3bd9b184232d78df925902cef0.png";